import { AHIcon, AHText, Box, TouchableBox } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion$key } from "./__generated__/WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion.graphql";
import { FormattedDateRawInWorkspace } from "../../../../common/dates/useFormattedDateRaw";

export function WorkspaceRoutineOccasionSelectButton(props: {
  routineWorkspaceOccasion: WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion$key;
  openOccasionsHistory: () => void;
}) {
  const routineWorkspaceOccasion = useFragment(
    graphql`
      fragment WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion on RoutineWorkspaceOccasion {
        startAt
        storesCompletedCount
        storesCount
      }
    `,
    props.routineWorkspaceOccasion
  );

  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceHorizontal="medium"
      spaceBottom="small"
    >
      <AHText type="subtitle" color="text-secondary">
        <FormattedMessage
          defaultMessage="Occasion:"
          description="WorkspaceRoutineOccasionSelectButton label"
        />
      </AHText>
      <TouchableBox
        style={{ flexDirection: "row", alignItems: "center" }}
        onPress={() => {
          props.openOccasionsHistory();
        }}
      >
        <AHText
          type="subtitle"
          color="primary"
          spaceHorizontal="small"
          spaceRight="none"
        >
          <FormattedDateRawInWorkspace
            dateISO={routineWorkspaceOccasion.startAt}
          />
          : {"  "}
          {routineWorkspaceOccasion.storesCompletedCount}/
          {routineWorkspaceOccasion.storesCount}
        </AHText>
        <AHIcon type="chevron-down" color="primary" />
      </TouchableBox>
    </Box>
  );
}
